<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row>
			<!-- <el-card> -->
			<el-row :gutter="20">
				<el-col :xs="24" :sm="8" :md="8">
					<el-input v-model="keywords" size="mini" placeholder="输入关键字搜索" maxlength="30" clearable style="margin:5px" @change="Search()">
						<el-button slot="append" icon="el-icon-search" @click="Search()"></el-button>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" style="margin-bottom: 20px;">
					<el-button style="margin: 5px;" size="mini" type="success" @click="addData()">新增关键人员</el-button>
					<!-- <el-button style="margin: 5px;" size="mini" @click="exportExcel()">导出</el-button> -->
				</el-col>
			</el-row>
			<el-table :data="tableData" style="width: 100%; " stripe>
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" :label-width="formLabelWidth" class="demo-table-expand">
							<el-row>
								<el-col :xs="24" :sm="12">
									<el-form-item label="科室">
										<span>{{ props.row.keyperson_dept }}</span>
									</el-form-item>
									<el-form-item label="姓名">
										<span>{{ props.row.keyperson_name }}</span>
									</el-form-item>
									<el-form-item label="性别">
										<span>{{ props.row.keyperson_gender }}</span>
									</el-form-item>
									<el-form-item label="年龄">
										<span>{{ props.row.keyperson_age }}</span>
									</el-form-item>
									<el-form-item label="职称">
										<span>{{ props.row.keyperson_job_title }}</span>
									</el-form-item>
									<el-form-item label="主要职务">
										<span>{{ props.row.keyperson_title }}</span>
									</el-form-item>
									<el-form-item label="联系方式">
										<span>{{ props.row.keyperson_contact }}</span>
									</el-form-item>
									<el-form-item label="身份证号">
										<span>{{ props.row.keyperson_id_card }}</span>
									</el-form-item>
									<el-form-item label="学历">
										<span>{{ props.row.keyperson_education_background }}</span>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="12">
									<el-form-item label="工作履历">
										<span>{{ props.row.keyperson_work_experience }}</span>
									</el-form-item>
									<el-form-item label="负责事务">
										<span>{{ props.row.keyperson_incharge }}</span>
									</el-form-item>
									<el-form-item label="办事风格">
										<span>{{ props.row.keyperson_work_style }}</span>
									</el-form-item>
									<el-form-item label="客情关系记录">
										<span>{{ props.row.keyperson_relationship_record }}</span>
									</el-form-item>
									<el-form-item label="备注">
										<span>{{ props.row.keyperson_remark }}</span>
									</el-form-item>
									<el-form-item label="上报人">
										<span>{{ props.row.keyperson_user__person_name }}</span>
									</el-form-item>
									<el-form-item label="创建时间">
										<span>
											{{
												props.row.create_date
													.split('T')
													.slice(0, 1)
													.join('')
											}}
										</span>
									</el-form-item>
									<el-form-item label="更新时间">
										<span>
											{{
												props.row.update_date
													.split('T')
													.slice(0, 1)
													.join('')
											}}
										</span>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</template>
				</el-table-column>

				<el-table-column label="科室" prop="keyperson_dept" show-overflow-tooltip sortable/>
				<el-table-column label="姓名" prop="keyperson_name" sortable/>
				<el-table-column label="性别" prop="keyperson_gender" sortable/>
				<el-table-column label="职务" prop="keyperson_title" show-overflow-tooltip sortable/>
				<el-table-column label="职称" prop="keyperson_job_title" show-overflow-tooltip sortable/>
				<el-table-column width="150" label="操作" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" @click="updateData(scope.$index, scope.row)">编 辑</el-button>
							<el-button size="mini" type="danger" @click="deleteData(scope.$index, scope.row)">删 除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-row class="paginator hidden-sm-and-down">
				<el-pagination
					background
					:current-page.sync="currentPage"
					layout="total, sizes, prev, pager, next"
					:total="totalItems"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
				/>
			</el-row>

			<el-row class="paginator hidden-sm-and-up">
				<el-pagination
					background
					:current-page.sync="currentPage"
					layout="prev, pager, next"
					:total="totalItems"
					:page-size="pageSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
					prev-text="上一页"
					next-text="下一页"
					:pager-count="5"
				/>
			</el-row>
			<!-- </el-card> -->
		</el-row>

		<!-- 新增数据表单 -->
		<el-dialog
			title="新增关键人员"
			:visible.sync="formAddDialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:width="'60%'"
			:fullscreen="ifFullScreen"
		>
			<el-form ref="formAddData" :rules="rules" :model="formAddData" :label-width="formLabelWidth" size="medium">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="姓名" prop="keyperson_name"><el-input v-model="formAddData.keyperson_name" clearable /></el-form-item>
						<el-form-item label="部门" prop="keyperson_dept"><el-input v-model="formAddData.keyperson_dept" clearable /></el-form-item>
						<el-form-item label="职务" prop="keyperson_title"><el-input v-model="formAddData.keyperson_title" clearable /></el-form-item>
						<el-form-item label="性别" prop="keyperson_gender">
							<el-radio-group v-model="formAddData.keyperson_gender" size="small">
								<el-radio-button label="女"></el-radio-button>
								<el-radio-button label="男" ></el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="职称" prop="keyperson_job_title"><el-input v-model="formAddData.keyperson_job_title" clearable /></el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="年龄" prop="keyperson_age">
							<el-input-number v-model="formAddData.keyperson_age" :min="1" :max="100" label="描述文字" size="small"></el-input-number>
						</el-form-item>
						<el-form-item label="联系方式" prop="keyperson_contact"><el-input v-model="formAddData.keyperson_contact" clearable /></el-form-item>
						<el-form-item label="身份证号" prop="keyperson_id_card"><el-input v-model="formAddData.keyperson_id_card" clearable /></el-form-item>
						<el-form-item label="学历" prop="keyperson_education_background"><el-input v-model="formAddData.keyperson_education_background" clearable /></el-form-item>
					</el-col>
				</el-row>

				<el-form-item label="工作履历" prop="keyperson_work_experience">
					<el-input v-model="formAddData.keyperson_work_experience" clearable type="textarea" maxlength="1000" show-word-limit />
				</el-form-item>
				<el-form-item label="负责事务" prop="keyperson_incharge">
					<el-input v-model="formAddData.keyperson_incharge" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="办事风格" prop="keyperson_work_style">
					<el-input v-model="formAddData.keyperson_work_style" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="客情关系记录" prop="keyperson_relationship_record">
					<el-input v-model="formAddData.keyperson_relationship_record" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="备注" prop="keyperson_remark">
					<el-input v-model="formAddData.keyperson_remark" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formAddData')">取 消</el-button>
				<el-button type="danger" @click="submitAddForm('formAddData')">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 更新数据表单 -->
		<el-dialog
			title="修改关键人员资料"
			:visible.sync="formUpdateDialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:fullscreen="ifFullScreen"
		>
			<el-form ref="formUpdateData" :rules="rules" :model="formUpdateData" :label-width="formLabelWidth" size="medium">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="姓名" prop="keyperson_name"><el-input v-model="formUpdateData.keyperson_name" clearable /></el-form-item>
						<el-form-item label="部门" prop="keyperson_dept"><el-input v-model="formUpdateData.keyperson_dept" clearable /></el-form-item>
						<el-form-item label="职务" prop="keyperson_title"><el-input v-model="formUpdateData.keyperson_title" clearable /></el-form-item>
						<el-form-item label="性别" prop="keyperson_gender">
							<el-radio-group v-model="formUpdateData.keyperson_gender" size="small">
								<el-radio-button label="女"></el-radio-button>
								<el-radio-button label="男" ></el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="职称" prop="keyperson_job_title"><el-input v-model="formUpdateData.keyperson_job_title" clearable /></el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="年龄" prop="keyperson_age">
							<el-input-number v-model="formUpdateData.keyperson_age" :min="1" :max="100" label="描述文字" size="small"></el-input-number>
						</el-form-item>
						<el-form-item label="联系方式" prop="keyperson_contact"><el-input v-model="formUpdateData.keyperson_contact" clearable /></el-form-item>
						<el-form-item label="身份证号" prop="keyperson_id_card"><el-input v-model="formUpdateData.keyperson_id_card" clearable /></el-form-item>
						<el-form-item label="学历" prop="keyperson_education_background"><el-input v-model="formUpdateData.keyperson_education_background" clearable /></el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="工作履历" prop="keyperson_work_experience">
					<el-input v-model="formUpdateData.keyperson_work_experience" clearable type="textarea" maxlength="1000" show-word-limit />
				</el-form-item>
				<el-form-item label="负责事务" prop="keyperson_incharge">
					<el-input v-model="formUpdateData.keyperson_incharge" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="办事风格" prop="keyperson_work_style">
					<el-input v-model="formUpdateData.keyperson_work_style" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="客情关系记录" prop="keyperson_relationship_record">
					<el-input v-model="formUpdateData.keyperson_relationship_record" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
				<el-form-item label="备注" prop="keyperson_remark">
					<el-input v-model="formUpdateData.keyperson_remark" clearable type="textarea" maxlength="1000" autosize show-word-limit />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formUpdateData')">取 消</el-button>
				<el-button type="primary" @click="submitUpdateForm('formUpdateData')">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { exportToExcel } from '@/api/utils.js';
export default {
	inject: ['reload', 'logout'],
	data() {
		return {
			tableData: [],
			keywords: '',
			formAddDialogVisible: false,
			formUpdateDialogVisible: false,
			ifFullScreen: false,
			formAddData: {
				pk: '',
				keyperson_dept: '',
				keyperson_name: '',
				keyperson_gender: '',
				keyperson_age: '',
				keyperson_job_title: '',
				keyperson_title: '',
				keyperson_contact: '',
				keyperson_id_card: '',
				keyperson_education_background: '',
				keyperson_work_experience: '',
				keyperson_incharge: '',
				keyperson_work_style: '',
				keyperson_relationship_record: '',
				keyperson_remark: ''
			},
			formUpdateData: {
				pk: '',
				keyperson_dept: '',
				keyperson_name: '',
				keyperson_gender: '',
				keyperson_age: '',
				keyperson_job_title: '',
				keyperson_title: '',
				keyperson_contact: '',
				keyperson_id_card: '',
				keyperson_education_background: '',
				keyperson_work_experience: '',
				keyperson_incharge: '',
				keyperson_work_style: '',
				keyperson_relationship_record: '',
				keyperson_remark: ''
			},
			//新增和更新表单的验证规则
			rules: {
				keyperson_dept: [{ required: true, message: '请填写科室或部门', trigger: 'blur' }],
				keyperson_name: [{ required: true, message: '请填写人员姓名', trigger: 'blur' }],
				keyperson_gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
				keyperson_title: [{ required: true, message: '请填写职务', trigger: 'blur' }],
				keyperson_job_title: [{ required: true, message: '请填写职称', trigger: 'blur' }]
			},
			formLabelWidth: '150px',
			totalItems: 100,
			currentPage: 1,
			pageSize: 20,
			deleteItemPk: '',
			loading: false
		};
	},
	methods: {
		//通用函数-获取数据
		getData(keywords, currentPage, pageSize) {
			var that = this;
			that.loading = true;
			this.$axios
				.get('/apim/get/keyperson/', {
					params: {
						keywords: keywords,
						currentpage: currentPage,
						pagesize: pageSize,
						cm_pk: that.$route.params.id
					}
				})
				.then(function(response) {
					if (response.data.code == '401') {
						that.logout();
					} else {
						that.tableData = response.data.data;
						that.totalItems = response.data.totalItemNum;
						that.loading = false;
					}
				})
				.catch(function(error) {
					console.log(error);
					that.loading = false;
				});
		},
		//通用功能 - 关键字搜索
		Search() {
			var that = this;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//新增数据-对话框
		addData() {
			this.formAddDialogVisible = true;
		},
		//新增数据-提交
		submitAddForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					var that = this;
					let fd = new FormData();
					let formData = this.formAddData;
					//添加表单数据
					for (let key in formData) {
						fd.append(key, formData[key]);
						// console.log(formData[key])
					}
					fd.append('cm_pk', that.$route.params.id);
					this.$axios({
						url: '/apim/add/keyperson/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
						.then(function(res) {
							// console.log(res.data);
							if (res.data.code == '200') {
								that.resetForm('formAddData')
								that.getData(that.keywords, that.currentPage, that.pageSize);
							} else {
								that.$message({
									message: res.data.message,
									type: 'warning'
								});
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				} else {
					return false;
				}
			});
		},
		//新增或更新数据 - 重置表单
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.formAddDialogVisible = false;
			this.formUpdateDialogVisible = false;
		},
		//更新数据 - 对话框
		updateData(index, row) {
			//解除双向绑定
			this.formUpdateData = JSON.parse(JSON.stringify(row));
			this.formUpdateDialogVisible = true;
		},
		//更新数据-提交
		submitUpdateForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					var that = this;
					let fd = new FormData();
					let formData = this.formUpdateData;
					//遍历添加表单数据
					for (let key in formData) {
						fd.append(key, formData[key]);
					}
					this.$axios({
						url: '/apim/update/keyperson/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
						.then(function(res) {
							if (res.data.code == '200') {
								that.formUpdateDialogVisible = false;
								that.getData(that.keywords, that.currentPage, that.pageSize);
							} else {
								that.$message({
									message: res.data.message,
									type: 'warning'
								});
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				} else {
					return false;
				}
			});
		},
		//删除数据 - 对话框
		deleteData(index, row) {
			let deleteItemPk = JSON.parse(JSON.stringify(row)).pk;
			this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.submitDeleteData(deleteItemPk);
				})
				.catch(() => {});
		},
		//删除数据-提交
		submitDeleteData(dataPk) {
			var that = this;
			var fd = new FormData();
			fd.append('pk', dataPk);
			this.$axios({
				url: '/apim/delete/keyperson/',
				method: 'post',
				data: fd,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
				.then(function(res) {
					// console.log(res.data);
					if (res.data.code == '200') {
						that.getData(that.keywords, that.currentPage, that.pageSize);
					} else {
						that.$message({
							message: res.data.message,
							type: 'warning'
						});
					}
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		//过滤器-产品分类：医用和民用
		filterTag(value, row) {
			return row.type === value;
		},

		//分页跳转
		handleCurrentChange(val) {
			var that = this;
			this.currentPage = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//每页显示条数更改
		handleSizeChange(val) {
			var that = this;
			this.pageSize = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//导出excel
		exportExcel() {
			exportToExcel('distributor', '经销商', this);
		}
	},
	mounted() {
		var that = this;
		this.getData('', that.currentPage, that.pageSize);
		that.ifFullScreen = document.body.clientWidth > 720 ? false : true;
	}
};
</script>

<style></style>
